import { Card, Badge } from "antd";
import { CATEGORY_COLORS } from "./colors";

export default function OrganizationModalContent({ dashboardData }) {
  const cardStyle = (borderColor) => ({
    padding: 16,
    borderLeft: `4px solid ${borderColor}`,
    borderRadius: 6,
  });

  const sectionTitle = (badgeColor, label, description) => (
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
      <Badge
        count={label}
        style={{
          backgroundColor: badgeColor,
          color: "#fff",
          padding: "0 8px",
          borderRadius: 4,
        }}
      />
      <span style={{ fontSize: 14, color: "#888" }}>{description}</span>
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
      <div>
        {sectionTitle(
          CATEGORY_COLORS.FAO.badgeBackground,
          "FAO",
          `${dashboardData.organizaciones.FAO.length} organizaciones registradas`
        )}
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {dashboardData.organizaciones.FAO.map((org, idx) => (
            <Card key={idx} style={cardStyle(CATEGORY_COLORS.FAO.borderColor)} size="small" hoverable>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
                <div style={{ flex: 1 }}>
                  <h6 style={{ fontWeight: 600, color: CATEGORY_COLORS.FAO.textColor, marginBottom: 4 }}>
                    {org.organizacion}
                  </h6>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <Badge
                      count={org.sigla}
                      style={{
                        backgroundColor: CATEGORY_COLORS.FAO.badgeBackground,
                        color: "#fff",
                        fontSize: 12,
                        marginTop: 5
                      }}
                    />
                    {org.Nit && (
                      <span
                        style={{
                          fontSize: 12,
                          backgroundColor: "#e5e5e5ff",
                          padding: "2px 6px",
                          borderRadius: 4,
                          color: "#000",
                        }}
                      >
                        NIT: {org.Nit}
                      </span>
                    )}
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: 12, color: "#999" }}>#{idx + 1}</div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
      {/* ORGANIZACIÓN */}
      <div>
        {sectionTitle(
          CATEGORY_COLORS.ORGANIZACIÓN.badgeBackground,
          "ORGANIZACIONES",
          `${dashboardData.organizaciones["ORGANIZACIÓN"].length} organizaciones registradas`
        )}
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {dashboardData.organizaciones["ORGANIZACIÓN"].map((org, idx) => (
            <Card key={idx} style={cardStyle(CATEGORY_COLORS.ORGANIZACIÓN.borderColor)} size="small" hoverable>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
                <div style={{ flex: 1 }}>
                  <h6 style={{ fontWeight: 600, color: CATEGORY_COLORS.ORGANIZACIÓN.textColor, marginBottom: 4 }}>
                    {org.organizacion}
                  </h6>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <Badge
                      count={org.sigla}
                      style={{
                        backgroundColor: CATEGORY_COLORS.ORGANIZACIÓN.badgeBackground,
                        color: "#fff",
                        fontSize: 12,
                        marginTop: 5
                      }}
                    />
                    {org.Nit && (
                      <span
                        style={{
                          fontSize: 12,
                          backgroundColor: "#e5e5e5ff",
                          padding: "2px 6px",
                          borderRadius: 4,
                          color: "#000",
                        }}
                      >
                        NIT: {org.Nit}
                      </span>
                    )}
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: 12, color: "#999" }}>#{idx + 1}</div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
      {/* POR ASIGNAR */}
      <div>
        {sectionTitle(
          CATEGORY_COLORS["POR ASIGNAR"].badgeBackground,
          "POR ASIGNAR",
          `${dashboardData.organizaciones["POR ASIGNAR"].length} organizaciones pendientes de asignación`
        )}
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {dashboardData.organizaciones["POR ASIGNAR"].map((org, idx) => (
            <Card key={idx} style={cardStyle(CATEGORY_COLORS["POR ASIGNAR"].borderColor)} size="small" hoverable>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
                <div style={{ flex: 1 }}>
                  <h6 style={{ fontWeight: 600, color: CATEGORY_COLORS["POR ASIGNAR"].textColor, marginBottom: 4 }}>
                    {org.organizacion}
                  </h6>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <Badge
                      count={org.sigla}
                      style={{
                        backgroundColor: CATEGORY_COLORS["POR ASIGNAR"].badgeBackground,
                        color: "#fff",
                        fontSize: 12,
                        marginTop: 5
                      }}
                    />
                    {org.Nit && (
                      <span
                        style={{
                          fontSize: 12,
                          backgroundColor: "#e5e5e5ff",
                          padding: "2px 6px",
                          borderRadius: 4,
                          color: "#000",
                        }}
                      >
                        NIT: {org.Nit}
                      </span>
                    )}
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: 12, color: "#999" }}>#{idx + 1}</div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
